import { configureStore } from '@reduxjs/toolkit';

import { apiSlice } from './apiSlice';
import alertBannerReducer from '../modules/AlertBanner';
import appReducer from '../modules/App';
import axiosReducer from '../modules/Axios';
import brandSwitcherReducer from '../routes/BrandSwitcher/modules/BrandSwitcher';
import createSegmentReducer from '../routes/Home/routes/CreateSegment/modules/CreateSegment';
import duplicateModalReducer from '../modules/DuplicateModal';
import editSegmentReducer from '../routes/Home/routes/EditSegment/modules/EditSegment';
import notificationsReducer from '../modules/Notifications';
import progressBarReducer from '../modules/ProgressBar';
import segmentDetailsReducer from '../routes/Home/routes/SegmentDetails/modules/SegmentDetails';
import segmentsReducer from '../routes/Home/routes/Segments/modules/Segments';
import campaignDetailsReducer from '../routes/Home/routes/CampaignDetails/modules/CampaignDetails';
import createCampaignReducer from '../routes/Home/routes/CreateCampaign/modules/CreateCampaign';
import administrationReducer from '../routes/Home/routes/Administration/modules/Administration';
import createIntegrationReducer from '../routes/Home/routes/CreateIntegration/modules/CreateIntegration';
import editIntegrationReducer from '../routes/Home/routes/EditIntegration/modules/EditIntegration';
import brandsReducer from '../routes/Admin/routes/Brands/modules/Brands';
import connectionsReducer from '../routes/Admin/routes/Connections/modules/Connections';
import tableReducer from '../modules/Table';
import explorerReducer from '../routes/Home/routes/DataExplorer/modules/DataExplorer';
import operationalDashboardReducer from '../routes/Home/routes/OperationalDashboard/modules/OperationalDashboard';

// Automatically adds the thunk middleware and the Redux DevTools extension
const store = configureStore({
  // Automatically calls `combineReducers`
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    alertBanner: alertBannerReducer,
    app: appReducer,
    axios: axiosReducer,
    brandSwitcher: brandSwitcherReducer,
    createSegment: createSegmentReducer,
    duplicateModal: duplicateModalReducer,
    editSegment: editSegmentReducer,
    notifications: notificationsReducer,
    progressBar: progressBarReducer,
    segmentDetails: segmentDetailsReducer,
    segments: segmentsReducer,
    campaignDetails: campaignDetailsReducer,
    createCampaign: createCampaignReducer,
    administration: administrationReducer,
    createIntegration: createIntegrationReducer,
    editIntegration: editIntegrationReducer,
    brands: brandsReducer,
    connections: connectionsReducer,
    table: tableReducer,
    explorer: explorerReducer,
    operationalDash: operationalDashboardReducer,
  },
  // Add the RTK Query API middleware
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiSlice.middleware),
});

export default store;
